// Copy for the Government page, kept apart from the markup so it is easy to edit.

import constants from "../../../config/config";

// Vimeo URL lives in config.js.
export const GOV_VIDEO_URL = constants.GOV_VIDEO_URL;

export const familyQuestions = [
  "Where are my family members?",
  "Are they safe?",
  "Where will we meet?",
  "What should we do?",
  "Where are our important documents?",
  "What did we own before our home was damaged?",
  "How do we begin recovering?",
];

export const beforeItems = [
  "Family members and household information",
  "Emergency contacts",
  "In-town and out-of-town meeting locations",
  "Emergency planning information",
  "Important documents and records",
  "Pet information",
  "Home inventory information",
  "Insurance and other recovery-related documentation",
];

export const flowSteps = [
  {
    label: "Access",
    body: "Resident visits the participating government's website and selects the community preparedness program.",
  },
  {
    label: "Enroll",
    body: "The resident follows the applicable enrollment or eligibility process established for the deployment.",
  },
  {
    label: "Build",
    body: "The household creates its family profile and begins developing its personalized emergency preparedness information.",
  },
  {
    label: "Prepare",
    body: "The family has a plan and preparedness information established before an emergency occurs.",
  },
];

export const afterAlertGroups = [
  { theme: "Family", questions: ["Where are their family members?", "Where will they meet?", "Can everyone Check-In?"] },
  { theme: "Information", questions: ["Where is their emergency information?", "Where are their important records?"] },
  { theme: "Home", questions: ["What happens if they cannot return home?", "Have they documented their possessions?"] },
  { theme: "Recovery", questions: ["How will they begin recovering?"] },
];

export const audiences = [
  "Cities and Municipalities",
  "Counties",
  "Tribal Governments",
  "Emergency Management Agencies",
  "Public Safety Organizations",
  "Territorial Governments",
  "Community Preparedness Programs",
];

export const leaderBenefits = [
  {
    title: "Extend preparedness into households",
    body: "Give residents a practical way to act on the preparedness guidance governments already promote.",
  },
  {
    title: "Encourage planning before emergencies",
    body: "Move household planning from the middle of a crisis to the days, months, and years before one.",
  },
  {
    title: "Strengthen family-level communication",
    body: "Provide participating households with tools designed around accounting for and communicating with loved ones.",
  },
  {
    title: "Complement existing emergency-management capabilities",
    body: "Add a family-centered layer without positioning MYREDFOLDER® as a replacement for established warning, response, or emergency-management systems.",
  },
  {
    title: "Support the transition from response to recovery",
    body: "Encourage residents to organize important records and property documentation before those records may be needed.",
  },
  {
    title: "Create a recognizable community preparedness initiative",
    body: "Through a white-labeled deployment, governments can provide residents with a locally identified program powered by MYREDFOLDER®.",
  },
];

export const imagineLines = [
  "Imagine thousands of households in your community establishing emergency plans before the next disaster.",
  "Imagine residents already knowing their family meeting locations.",
  "Imagine families having important information organized before evacuation becomes necessary.",
  "Imagine family members being able to Check-In when they are separated.",
  "Imagine residents documenting their homes and possessions before a loss.",
  "Imagine government emergency communications reaching participating residents while those residents already have a family plan to put into action.",
];

export const governmentPrepares = [
  "Emergency operations plans",
  "Continuity procedures",
  "Warning systems",
  "Evacuation strategies",
  "Response capabilities",
  "Recovery programs",
];

export const residentsMust = [
  "Receive the warning",
  "Locate their loved ones",
  "Make decisions",
  "Evacuate when necessary",
  "Protect critical information",
  "Care for children and pets",
  "Put their lives back together",
];

export const residentCapabilities = [
  { title: "Plan ahead", body: "Establish personalized family emergency plans before an emergency occurs." },
  { title: "Access information", body: "Reach important household information when it is needed." },
  { title: "Stay connected", body: "Communicate and account for loved ones during an emergency." },
  { title: "Prepare to recover", body: "Organize information that can help support recovery afterward." },
];
